import {
  Icon,
  getTranslatedText,
  ModalContent,
  HourGlassLoader,
  T2
} from '@nile/components';
import { Link } from '@superops/ui-design-system';
import {
  Sheet,
  Button,
  ButtonGroup,
  Heading
} from '@superops/ui-design-system';
import { FileImport } from '@styled-icons/fa-solid';
import React, { useState, useCallback } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import envConfig from '@nile/home/src/Config/env';
import {
  DropZoneSingle,
  DropZoneMultiple
} from '@nile/components/src/Modals/PromptModal';
import {
  ImportSummaryCard,
  ErrorCard
} from '@nile/components/src/Pebbles/ImportSheet';
import { SVGIcon } from '@superops/super-icons';

const InfoContainer = styled.div`
  display: flex;
  background: #ffffff;
  margin: 20px 40px;
  margin-left: 0;
  margin-right: 0;
  .Polaris-Subheading {
    margin-top: 8px !important;
  }
`;

const ImportSheet = (props) => {
  const {
    intl,
    meta,
    data,
    isLink,
    name,
    hideIcon,
    noRender,
    icon,
    noName,
    module,
    details,
    sampleFile,
    showSummary,
    isLoading,
    loadingText,
    type
  } = props;

  const [file, setFile] = useState(null);
  // For multiple file upload
  const [files, setFiles] = useState([]);

  const [active, setActive] = useState(false);

  const [isCollapsed, setCollapse] = useState(false);

  const toggleCollapsible = useCallback(() => {
    setCollapse(!isCollapsed);
  }, []);

  const resetFiles = () => {
    setFile(null);
    setFiles([]);
  };

  const handleChange = useCallback(() => {
    setActive(!active);
    resetFiles();
  }, [active]);

  const submitHandler = async (inpFile) => {
    await props.handleSubmit(inpFile);
  };

  const handlePrimaryAction = useCallback(() => {
    if (file && props.handleSubmit) {
      submitHandler(file);
    }
    if (files.length && props.handleSubmit) {
      submitHandler(files);
    }
    if (showSummary) {
      resetFiles();
    } else {
      handleChange();
    }
  });

  const stopEvents = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  //TODO: Get download sample CSV from backend
  return (
    <div>
      {!noRender && (
        <div id="importEmployeeBtn">
          <Button secondary onClick={handleChange} plain={isLink}>
            <span className="fx actr">
              {!hideIcon && (
                <div className="mr8 flex jctr actr">
                  <SVGIcon name="Import" />
                </div>
              )}
              {!noName &&
                (name || getTranslatedText(intl, 'admin.employee.import'))}
            </span>
          </Button>
        </div>
      )}
      <Sheet open={active} onClose={handleChange}>
        <ModalContent style={{ width: '600px' }}>
          <div>
            <InfoContainer>
              <div className="fx2">
                <Heading element="h1">
                  {meta?.title ||
                    getTranslatedText(intl, 'admin.technicians.import.title')}
                </Heading>
              </div>
              <div className="fx fx2 jend actr save-card " data-qa="taskBtns">
                <ButtonGroup>
                  <Button plain onClick={handleChange}>
                    <FormattedMessage id="common.cancel" />
                  </Button>
                  <Button
                    submit
                    primary
                    onClick={handlePrimaryAction}
                    icon={<SVGIcon name="Import" />}
                  >
                    {getTranslatedText(intl, 'admin.employee.import')}
                  </Button>
                </ButtonGroup>
              </div>
            </InfoContainer>
            <div>
              <div className="mb-10">
                <T2>
                  {meta?.description ||
                    getTranslatedText(intl, 'admin.technicians.import.desc')}
                </T2>
              </div>
              <div className="mb-10">
                <Link
                  url={`${envConfig.imageRoot}${sampleFile}`}
                  removeUnderline
                >
                  <FormattedMessage id="admin.technician.import.download" />
                </Link>
              </div>
              <div>
                {props.allowMultiple ? (
                  <DropZoneMultiple
                    files={files}
                    setFiles={setFiles}
                    allowMultiple={props.allowMultiple}
                  />
                ) : (
                  <DropZoneSingle file={file} setFile={setFile} />
                )}
              </div>
              {isLoading && (
                <HourGlassLoader
                  heading={loadingText}
                  imageURL={`${envConfig.imageRoot}svg/Hourglass.svg`}
                  boxWidth="470px"
                />
              )}
              {data?.status && (
                <ImportSummaryCard
                  data={data}
                  toggleCollapsible={toggleCollapsible}
                  type={type}
                />
              )}
              {data?.status && data?.failedList?.length > 0 && (
                <ErrorCard data={data?.failedList} />
              )}
            </div>
          </div>
        </ModalContent>
      </Sheet>
    </div>
  );
};

export default injectIntl(ImportSheet);
